import React from 'react';
import { forlandingpageContent } from '../rich-content/forlandingpage-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const ForlandingpageDetailPage = () => {
  return <AutomaticPageBuilder content={forlandingpageContent} />;
};

export default ForlandingpageDetailPage;
